import PermissionsEnum from 'src/enum/PermissionsEnum';
import React, { lazy } from 'react';
import RoutesEnum from 'src/enum/RoutesEnum';

export const authGuardAdminRoutes = [
  {
    exact: true,
    path: RoutesEnum.ADMIN_DASHBOARD_ROUTE,
    permission: PermissionsEnum.VIEW_VEHICLES_IN_PDI,
    component: lazy(() => import('src/pages/dashboard')),
  },
  {
    exact: true,
    path: RoutesEnum.ADMIN_LAST_MILE_TRACK_ROUTE,
    permission: PermissionsEnum.VIEW_LAST_MILE_TRACK,
    component: lazy(() => import('src/pages/lastMileTrack')),
  },
  {
    exact: true,
    path: RoutesEnum.ADMIN_MONITORING_VEHICLES_ROUTE,
    permission: PermissionsEnum.VIEW_VEHICLE_MONITORING,
    component: lazy(() => import('src/pages/monitoringVehicles')),
  },
  {
    exact: true,
    path: RoutesEnum.ADMIN_REPORT_DISPATCHED_VEHICLES_ROUTE,
    permission: PermissionsEnum.VIEW_DISPATCHED_REPORT,
    component: lazy(() => import('src/pages/reportDispatchedVehicles')),
  },
  {
    exact: true,
    path: RoutesEnum.OPERATIONAL_METRICS_PAGE_ADMIN_ROUTE,
    permission: PermissionsEnum.VIEW_OPERATIONAL_METRICS,
    component: lazy(() => import('src/pages/operationalMetricsPage')),
  },
  {
    exact: true,
    path: RoutesEnum.STOCK_PAGE_ADMIN_ROUTE,
    permission: PermissionsEnum.VIEW_INVENTORY,
    component: lazy(() => import('src/pages/stockPage')),
  },
  {
    exact: true,
    path: RoutesEnum.MANAGE_REVIEWS_ADMIN_ROUTE,  
    permission: PermissionsEnum.VIEW_MANAGE_REVIEWS,
    component: lazy(() => import('src/pages/platform-rating')),
  },
  {
    exact: true,
    path: RoutesEnum.VIEW_CLIENT_ROUTE, 
    permission: PermissionsEnum.VIEW_CUSTOMERS,
    component: lazy(() => import('src/pages/clientsPage')),
  },
  {
    exact: true,
    path: RoutesEnum.EDIT_CLIENT_ROUTE,
    permission: PermissionsEnum.EDIT_CUSTOMERS,
    component: lazy(() => import('src/pages/clientsPage/views/editClient')),
  },
  {
    exact: true,
    path: RoutesEnum.ADD_USER_ROUTE,
    permission: PermissionsEnum.EDIT_CUSTOMERS,
    component: lazy(() => import('src/pages/clientsPage/views/addUser')),
  },
  {
    exact: true,
    path: RoutesEnum.VIEW_TEAM_ROUTE,
    permission: PermissionsEnum.VIEW_TEAM,
    component: lazy(() => import('src/pages/teamPage')),
  },
  {
    exact: true,
    path: RoutesEnum.VIEW_GROUP_ROUTE,
    permission: PermissionsEnum.VIEW_GROUP_ROUTE,
    component: lazy(() => import('src/pages/groupPage')),
  },
  {
    exact: true,
    path: RoutesEnum.VIEW_GROUP_USERS_ROUTE,
    permission: PermissionsEnum.VIEW_GROUP_ROUTE,
    component: lazy(() => import('src/pages/groupPage/components/ListUsersGroups')),
  },
  {
    exact: true,
    path: RoutesEnum.ADD_GROUP_ROUTE,
    permission: PermissionsEnum.EDIT_GROUP_ROUTE,
    component: lazy(() => import('src/pages/groupPage/components/AddEditGroups')),
  },
  {
    exact: true,
    path: RoutesEnum.EDIT_GROUP_ROUTE,
    permission: PermissionsEnum.EDIT_GROUP_ROUTE,
    component: lazy(() => import('src/pages/groupPage/components/AddEditGroups')),
  },
  {
    exact: true,
    path: RoutesEnum.EDIT_USER_ROUTE,
    component: lazy(() => import('src/pages/clientsPage/views/editUser')),
  },
  {
    exact: true,
    path: RoutesEnum.ADMIN_REQUEST_PREPARATION_LIST_ROUTE,
    permission: PermissionsEnum.VIEW_REQUESTS,
    component: lazy(() => import('src/pages/requestPreparation/adminListRequestPreparation')),
  },
  {
    exact: true,
    path: RoutesEnum.ADMIN_REQUEST_PREPARATION_CREATE_ROUTE,
    permission: PermissionsEnum.EDIT_REQUESTS,
    component: lazy(() => import('src/pages/requestPreparation/createRequestPreparation')),
  },
  {
    exact: true,
    path: RoutesEnum.ADMIN_VIEW_SEARCH_VEHICLES_ROUTE,
    permission: PermissionsEnum.VIEW_INVENTORY,
    component: lazy(() => import('src/pages/searchVehiclesPage')),
  }
]
